export const PLATFORM_ROLE_TYPE_VALUES = ['system', 'admin', 'user'] as const;
export type PlatformRoleType = (typeof PLATFORM_ROLE_TYPE_VALUES)[number];
export const PLATFORM_ROLE_TYPES_PARAM = PLATFORM_ROLE_TYPE_VALUES.join(',');

export function isPlatformRoleType(
  roleType: string | null | undefined,
): roleType is PlatformRoleType {
  return PLATFORM_ROLE_TYPE_VALUES.includes(roleType as PlatformRoleType);
}

export interface AdminRoleRow {
  roleid: string;
  name: string;
  title: string | null;
  description: string | null;
  roleType: string;
  isBuiltin: boolean;
  viewAllData: boolean;
  businessUnitName: string | null;
  memberCount: number;
  privilegeCount: number;
  appCount: number;
  viewBusinessUnitCount: number;
  viewBusinessUnitNames: string[];
  modifiedOn: string | null;
  instanceCount?: number;
}

export interface PlatformRoleDetail extends AdminRoleRow {
  members: PlatformRoleMember[];
  apps: Array<{ appid: string; name: string; displayNameZh: string }>;
  visibleSitemapIds: string[];
}

export interface PlatformRoleMember {
  systemuserid: string;
  fullname: string | null;
  domainname: string | null;
  email: string | null;
  businessUnitName: string | null;
}

export interface PlatformAppRow {
  appid: string;
  name: string;
  display_name_zh: string;
  display_order: number;
}

export interface PlatformSitemapNode {
  sitemap_id: string;
  appid: string;
  parent_id: string | null;
  display_order: number;
  display_name_zh: string;
  display_name_en: string;
  custom_url: string | null;
}

export interface PlatformSitemapNodesResponse {
  apps: PlatformAppRow[];
  items: PlatformSitemapNode[];
}

export type PlatformPermissionTabKey = 'general' | 'apps' | 'menu' | 'privileges';
